import request from '@/utils/request'

export function getSaleConfig() {
  return request({ url: '/admin/sale/config', method: 'post', data: {} })
}

export function getSalePackageList() {
  return request({ url: '/admin/sale/packageList', method: 'post', data: {} })
}

export function createSalePackage(data) {
  return request({ url: '/admin/sale/packageCreate', method: 'post', data })
}

export function updateSalePackage(data) {
  return request({ url: '/admin/sale/packageUpdate', method: 'post', data })
}

export function deleteSalePackage(data) {
  return request({ url: '/admin/sale/packageDelete', method: 'post', data })
}
